/** Product analytics contract — business outcomes only. */
export const AnalyticsEvents = {
  landingPageView: "landing_page_view",
  pricingPageView: "pricing_page_view",
  heroGetStartedClicked: "hero_get_started_clicked",

  accountCreated: "account_created",
  loginSuccess: "login_success",
  oauthSignupGoogle: "oauth_signup_google",
  oauthSignupGithub: "oauth_signup_github",

  folderCreated: "folder_created",
  notebookCreated: "notebook_created",
  firstNotebookCreated: "first_notebook_created",
  notebookOpened: "notebook_opened",
  notebookPublished: "notebook_published",

  quickNoteCreated: "quick_note_created",
  feedbackSent: "feedback_sent",

  subscriptionStarted: "subscription_started",
  subscriptionUpgraded: "subscription_upgraded",
  subscriptionCancelled: "subscription_cancelled",
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
